/**
 * The single source of truth for rendering the Tradeski wordmark, per §8.6.
 *
 * Light and dark variants live under `/branding/` in `public/`. We swap the
 * `src` based on `document.documentElement.dataset.theme`, observed via a
 * MutationObserver so the header toggle flips the image instantly.
 */

import { useEffect, useState } from 'react'

type Props = {
    className?: string
}

export const Logo = ({ className }: Props) => {
    const [dark, setDark] = useState(() => document.documentElement.dataset.theme === 'dark')

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setDark(document.documentElement.dataset.theme === 'dark')
        })
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
        })
        return () => observer.disconnect()
    }, [])

    const src = dark ? '/branding/tradeski-logo-dark.png' : '/branding/tradeski-logo.png'
    return (
        <img
            src={src}
            alt="Tradeski"
            className={['block w-auto select-none', className].filter(Boolean).join(' ')}
            loading="eager"
            draggable={false}
        />
    )
}
